import { useEffect } from 'react';
import { getNextFocusableElement, getPreviousFocusableElement, getTabbableElements, } from '@anwb/tabbable';
export const useTabObserver = ({ root, onTabOut }) => {
    useEffect(() => {
        if (root === null) {
            return () => { };
        }
        const eventHandler = (event) => {
            if (event.key !== 'Tab') {
                return;
            }
            const direction = event.shiftKey ? 'backward' : 'forward';
            const activeElement = document.activeElement;
            const tabbableElements = getTabbableElements(root);
            const element = event.shiftKey
                ? getPreviousFocusableElement({ activeElement, tabbableElements })
                : getNextFocusableElement({ activeElement, tabbableElements });
            if (element === null) {
                event.preventDefault();
                onTabOut({ tabbableElements, activeElement, direction });
            }
        };
        root.addEventListener('keydown', eventHandler);
        return () => {
            root.removeEventListener('keydown', eventHandler);
        };
    }, [onTabOut, root]);
};
//# sourceMappingURL=useTabObserver.js.map